import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]',
  standalone: false
})
export class OnlyNumbersDirective {
  constructor(private el: ElementRef<HTMLInputElement>){

  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if(['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(event.key)){
      return;
    }
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if(event.key >= '0' && event.key <= '9'){
      return;
    }

    if(event.key === '-' && value.length === 0){
      return;
    }

    if(event.key === '.' && value.length > 0 && !value.includes('.')){
      return;
    }
    event.preventDefault();
  }

  // @HostListener('input')
  // onInput() {
  //   const cleaned = this.el.nativeElement.value.replace(/\D+/g, '');
  //   if(this.el.nativeElement.value !== cleaned){
  //     this.el.nativeElement.value = cleaned;
  //   }
  // }

  // @HostListener('paste', ['$event'])
  // onPaste(event: ClipboardEvent) {
  //   const pastedInput: string = event.clipboardData?.getData('text') ?? '';
  //   if(!/^[0-9],.$/.test(pastedInput)){
  //     event.preventDefault();
  //   }
  // }

}
